import { cva } from "class-variance-authority";
import { jsx } from "react/jsx-runtime";
//#region src/blocks/EmptyState/EmptyState.tsx
const emptyStateClassnames = cva([
	"tw:flex",
	"tw:flex-col",
	"tw:items-center",
	"tw:text-center"
], {
	variants: { variant: {
		default: [
			"tw:py-16",
			"tw:px-8",
			"tw:gap-4"
		],
		compact: [
			"tw:py-8",
			"tw:px-4",
			"tw:gap-2"
		]
	} },
	defaultVariants: { variant: "default" }
});
const emptyStateIconClassnames = cva([
	"tw:flex",
	"tw:items-center",
	"tw:justify-center",
	"tw:text-muted-foreground"
], {
	variants: { variant: {
		default: [
			"tw:size-16",
			"tw:text-4xl",
			"tw:[&_svg:not([class*=\"tw:size-\"])]:size-10"
		],
		compact: [
			"tw:size-10",
			"tw:text-2xl",
			"tw:[&_svg:not([class*=\"tw:size-\"])]:size-6"
		]
	} },
	defaultVariants: { variant: "default" }
});
const emptyStateTitleClassnames = cva([
	"tw:m-0",
	"tw:font-semibold",
	"tw:text-foreground"
], {
	variants: { variant: {
		default: ["tw:text-lg", "tw:leading-7"],
		compact: ["tw:text-base", "tw:leading-6"]
	} },
	defaultVariants: { variant: "default" }
});
const emptyStateDescriptionClassnames = cva(["tw:m-0", "tw:text-muted-foreground"], {
	variants: { variant: {
		default: [
			"tw:text-sm",
			"tw:leading-5",
			"tw:max-w-sm"
		],
		compact: [
			"tw:text-xs",
			"tw:leading-4",
			"tw:max-w-xs"
		]
	} },
	defaultVariants: { variant: "default" }
});
const emptyStateActionsClassnames = cva([
	"tw:flex",
	"tw:items-center",
	"tw:flex-wrap"
], {
	variants: { variant: {
		default: ["tw:gap-3", "tw:mt-2"],
		compact: ["tw:gap-2", "tw:mt-1"]
	} },
	defaultVariants: { variant: "default" }
});
/**
* "Nothing here yet" placeholder with icon, title, description and actions slots.
*
* - For intentionally empty surfaces; guide the user to the next action.
* - Not for errors (`ErrorState`), loading (`Skeleton`) or search misses (`EmptySearchContent`).
* - Use `variant="compact"` inside a `Card`.
* @see RECIPES.md#card-with-empty-state
*/
const EmptyStateRoot = ({ className, variant = "default", children, ...rest }) => /* @__PURE__ */ jsx("div", {
	role: "status",
	className: emptyStateClassnames({
		className,
		variant
	}),
	...rest,
	children
});
const EmptyStateIcon = ({ className, variant = "default", children, ...rest }) => /* @__PURE__ */ jsx("div", {
	className: emptyStateIconClassnames({
		className,
		variant
	}),
	...rest,
	children
});
const EmptyStateTitle = ({ className, variant = "default", children, ...rest }) => /* @__PURE__ */ jsx("h3", {
	className: emptyStateTitleClassnames({
		className,
		variant
	}),
	...rest,
	children
});
const EmptyStateDescription = ({ className, variant = "default", children, ...rest }) => /* @__PURE__ */ jsx("p", {
	className: emptyStateDescriptionClassnames({
		className,
		variant
	}),
	...rest,
	children
});
const EmptyStateActions = ({ className, variant = "default", children, ...rest }) => /* @__PURE__ */ jsx("div", {
	className: emptyStateActionsClassnames({
		className,
		variant
	}),
	...rest,
	children
});
const EmptyState = EmptyStateRoot;
EmptyState.Icon = EmptyStateIcon;
EmptyState.Title = EmptyStateTitle;
EmptyState.Description = EmptyStateDescription;
EmptyState.Actions = EmptyStateActions;
//#endregion
export { EmptyState };

//# sourceMappingURL=EmptyState.js.map